import { CoeToDoWork } from "src/models/coeToDoWork";
import { createEntityModel } from "src/store/models/entity/_shared";

export const CoeToDoWorkEntityModel = createEntityModel<CoeToDoWork>();
